import { useQuery } from '@tanstack/react-query';

import UsersService from '~/services/UsersService';

import { usersQueryKeys } from './usersQueryKeys';

export function useGetAccountIdentityActivityLogs(accountId: string) {
  return useQuery({
    queryKey: usersQueryKeys.identityActivityList(accountId),
    queryFn: ({ signal }) => UsersService.getAccountIdentityActivity(accountId, { signal }),
    enabled: Boolean(accountId),
  });
}
